import React, { useState, useEffect } from 'react'
import FormSubmissionHandler from '../../../UIComponents/FormSubmissionHandler';
// import SelectBoxHandler from '../../../UIComponents/SelectBoxHandler';
// import CheckBoxHandler from '../../../UIComponents/CheckBoxHandler';
// import CustomImage from '../../../UIComponents/CustomImage';
// import CustomLink from '../../../UIComponents/CustomLink';
import FileUploadHandler from '../../../UIComponents/FileUploadHandler';
import NormalTextareaHandler from '../../../UIComponents/NormalTextareaHandler';
// import RadioButtonHandler from '../../../UIComponents/RadioButtonHandler';
// import TextareaHandler from '../../../UIComponents/TextareaHandler';
import InputHandler from '../../../UIComponents/InputHandler';
import Loader from '../../../UIComponents/Loader';
import { postAPI, postAPIForm, getURL } from '../../../app/api';
import { store } from '../../../app/store';
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import { useParams } from 'react-router-dom';
import './tooltip.css';
import { hasPermission, isAdmin } from '../../../store/hooks/Permission';
import Excel from '../../../components/Excel/Excel';
import { DownloadOutlined } from '@ant-design/icons';

export default function List({PopupID="", setIsEdit, setEditId}) {
    const {exam_id} = useParams();
    const [IsBTNClicked, setIsBTNClicked] = useState(false);
    const store_data = JSON.parse(store());
    const [RewardSetupData, setRewardSetupData] = useState([]);
    const [Loading, setLoading] = useState(true);
    
    // Permission states
    const [canView, setCanView] = useState(false);
    const [canCreate, setCanCreate] = useState(false);
    const [canEdit, setCanEdit] = useState(false);
    const [canDelete, setCanDelete] = useState(false);
    const [canExport, setCanExport] = useState(false);

    const fetchRewardSetupData = async () => {
        const filter = { id: store_data?.org_id, exam_id: exam_id }
        const response = await postAPI("/reward-setup/exam-wise-list", {...filter, user: store_data});
        if (response?.status) {
            setRewardSetupData(response?.data)
            setLoading(false)
        } else {
            setRewardSetupData([])
            setLoading(false)
        }
    }

    const handleChangeStatus = async (id, status) => {
        if (!canEdit) {
            toast.error('You do not have permission to perform this action');
            return;
        }
        const filter = { org_id: store_data?.org_id, id: id, status: status }
        const response = await postAPI("/reward-setup/toggle-status", {...filter, user: store_data});
        if (response?.status == 1) {
            toast.success('Status changed successfully.');
            window.location.reload()
        } else {
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }

    const handleRemove = async id => {
        if (!canDelete) {
            toast.error('You do not have permission to perform this action');
            return;
        }
        const filter = { org_id: store_data?.org_id, id: id }
        const response = await postAPI("/reward-setup/remove", {...filter, user: store_data});
        if (response?.status == 1) {
            toast.success('Additional charges removed successfully.');
            window.location.reload()
        } else {
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }

    useEffect(() => {
        const checkPermissions = async () => {
            if (isAdmin()) {
                setCanView(true);
                setCanCreate(true);
                setCanEdit(true);
                setCanDelete(true);
                fetchRewardSetupData();
            } else {
                const viewAllowed = await hasPermission("REWARDS", "RewardSetup", "VIEW");
                const createAllowed = await hasPermission("REWARDS", "RewardSetup", "CREATE");
                const editAllowed = await hasPermission("REWARDS", "RewardSetup", "EDIT");
                const deleteAllowed = await hasPermission("REWARDS", "RewardSetup", "DELETE");
                
                setCanView(viewAllowed);
                setCanCreate(createAllowed);
                setCanEdit(editAllowed);
                setCanDelete(deleteAllowed);
                
                if (viewAllowed) {
                    fetchRewardSetupData();
                }
            }
        };
        checkPermissions();
    }, [])
    return (
        <>
            <ToastContainer />
            <table class="table card-table">
                <thead>
                    <tr>
                        <th>Rank</th>
                        <th>Reward Amount</th>
                        {/* <th>Status</th> */}
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody class="table-border-bottom-0">
                    {
                        !canView ? (
                            <tr>
                                <td colSpan="3" className="text-center text-danger py-4">
                                    You do not have permission to view this page.
                                </td>
                            </tr>
                        ) : RewardSetupData && RewardSetupData?.length > 0 ?
                            RewardSetupData?.map((val, index) => (
                                <tr>
                                    <td>{val?.rank}</td>
                                    <td>{val?.reward_amount}</td>
                                    {/* <td><span className={`badge ${val?.status === 1 ? 'bg-label-success' : 'bg-label-secondary'} me-1 cursor-pointer`} onClick={() => handleChangeStatus(val?.id, !val?.status)}>{val?.status === 1 ? 'Active' : 'Inactive'}</span></td> */}
                                    <td>
                                        {/* <span className="badge bg-label-primary me-1"><i className="fa-regular fa-eye"></i></span> */}
                                        {/* <span className="badge bg-label-primary me-1" data-bs-toggle="modal" data-bs-target={`#${PopupID}`} onClick={() => {setIsEdit(true);setEditId(val?.id);}}><i className="fa fa-pen"></i></span> */}
                                        <span className="custom-tooltip">
                                            <span className="badge bg-label-danger me-1 cursor-pointer"
                                                onClick={() => {
                                                    if (window.confirm("Are you sure? This action will permanently remove this data!")) {
                                                        handleRemove(val?.id);
                                                    } else {
                                                        console.log("Remove cancelled.");
                                                    }
                                                }}
                                            ><i className="fa fa-trash"></i></span>
                                            <span className="tooltip-text">Delete Reward</span>
                                        </span>
                                    </td>
                                </tr>
                            ))
                            : ''
                    }
                </tbody>
            </table>
        </>
    )
}
